// src/data/bancos.js
const bancos = [
    { codigo: "001 - Banco do Brasil S.A.", nome: "001 - Banco do Brasil S.A." },
    { codigo: "033 - Banco Santander (Brasil) S.A.", nome: "033 - Banco Santander (Brasil) S.A." },
    { codigo: "104 - Caixa Econômica Federal", nome: "104 - Caixa Econômica Federal" },
    { codigo: "237 - Banco Bradesco S.A.", nome: "237 - Banco Bradesco S.A." },
    { codigo: "341 - Itaú Unibanco S.A.", nome: "341 - Itaú Unibanco S.A." },
    { codigo: "260 - Nu Pagamentos S.A. (Nubank)", nome: "260 - Nu Pagamentos S.A. (Nubank)" },
    { codigo: "336 - Banco C6 S.A. (C6 Bank)", nome: "336 - Banco C6 S.A. (C6 Bank)" },
    { codigo: "077 - Banco Inter S.A.", nome: "077 - Banco Inter S.A." },
    // Adicione mais bancos conforme necessário
];

export default bancos;
